function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.917
}, React.createElement("path", {
  d: "M827.095 524.433l15.465-3.829-9.812-13.495z",
  fill: "#ff7f7f"
}), React.createElement("path", {
  d: "M827.094 524.433l-3.11-12.545 8.765-4.779z",
  fill: "#e25081"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.917
}, React.createElement("path", {
  d: "M779.826 326.648l8.763-12.965-16.031-3.39z",
  fill: "#ff7f7f"
}), React.createElement("path", {
  d: "M779.826 326.648l-10.518-7.104 3.25-9.25z",
  fill: "#e25081"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.917
}, React.createElement("path", {
  d: "M145.536 383.438l-1.477 15.865 15.972-4.821z",
  fill: "#ff7f7f"
}), React.createElement("path", {
  d: "M145.536 383.438l12.869 1.195 1.626 9.849z",
  fill: "#e25081"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.917
}, React.createElement("path", {
  d: "M575.644 505.406l-15.657 2.954 9.038 14.025z",
  fill: "#ff7f7f"
}), React.createElement("path", {
  d: "M575.643 505.406l2.4 12.7-9.019 4.278z",
  fill: "#e25081"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.917
}, React.createElement("path", {
  d: "M857.339 190.363l2.63 10.2 8.859-6.574z",
  fill: "#ff7f7f"
}), React.createElement("path", {
  d: "M857.339 190.363l8.275-2.137 3.216 5.763z",
  fill: "#e25081"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.917
}, React.createElement("path", {
  d: "M127.282 204.993l-7.055 7.822 10.369 3.76z",
  fill: "#ff7f7f"
}), React.createElement("path", {
  d: "M127.282 204.993l6.349 5.72-3.032 5.863z",
  fill: "#e25081"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.917
}, React.createElement("path", {
  d: "M254.271 478.723l5.9 2.753.344-6.81z",
  fill: "#ff7f7f"
}), React.createElement("path", {
  d: "M254.271 478.723l2.231-4.787 4.013.73z",
  fill: "#e25081"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.917
}, React.createElement("path", {
  d: "M384.326 379.91l6.333 1.513-1.029-6.74z",
  fill: "#ff7f7f"
}), React.createElement("path", {
  d: "M384.326 379.91l1.226-5.138 4.078-.09z",
  fill: "#e25081"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.917
}, React.createElement("path", {
  d: "M526.157 308.203l9.515 4.519.633-11.013z",
  fill: "#ff7f7f"
}), React.createElement("path", {
  d: "M526.157 308.203l3.665-7.721 6.484 1.226z",
  fill: "#e25081"
}));

var SvgConfetti = function SvgConfetti(props) {
  return React.createElement("svg", _extends({
    height: 551.11,
    width: 992.826
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default "data:image/svg+xml;base64,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";
export { SvgConfetti as ReactComponent };